import type { PdfCanvasPoint, PdfCanvasStroke } from "./pdfCanvasTypes";

function distanceSqToSegment(p: PdfCanvasPoint, a: PdfCanvasPoint, b: PdfCanvasPoint): number {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const lengthSq = dx * dx + dy * dy;
    const t = lengthSq === 0 ? 0 : Math.min(1, Math.max(0, ((p.x - a.x) * dx + (p.y - a.y) * dy) / lengthSq));
    const cx = a.x + t * dx - p.x;
    const cy = a.y + t * dy - p.y;
    return cx * cx + cy * cy;
}

/**
 * Noktanın üzerinde olduğu, nota bağlı en üstteki draw stroke'unu döner.
 * Koordinatlar sayfa natural boyutundadır; `tolerance` fırça yarıçapına eklenir.
 */
export function findNotStrokeAtPoint(
    strokes: PdfCanvasStroke[],
    point: PdfCanvasPoint,
    tolerance: number,
): PdfCanvasStroke | null {
    for (let i = strokes.length - 1; i >= 0; i--) {
        const stroke = strokes[i];
        if (stroke.tool !== "draw" || !stroke.notId || stroke.points.length === 0) {
            continue;
        }

        const reach = stroke.radius + tolerance;
        const reachSq = reach * reach;
        const points = stroke.points;
        if (points.length === 1) {
            if (distanceSqToSegment(point, points[0], points[0]) <= reachSq) {
                return stroke;
            }
            continue;
        }

        for (let j = 1; j < points.length; j++) {
            if (distanceSqToSegment(point, points[j - 1], points[j]) <= reachSq) {
                return stroke;
            }
        }
    }

    return null;
}
